var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-decoration-12',{key:_vm.key,staticClass:"decoration-container",attrs:{"color":_vm.color,"scanDur":_vm.scanDur,"haloDur":_vm.haloDur}})
}
var staticRenderFns = []

export { render, staticRenderFns }